@if (enableVisualization() && visualizationConfig().visualizationType !== noVisualization) {
    <ms-my-bets-visualization
        [event]="event()"
        [bet]="bet()"
        [visualizationType]="visualizationConfig().visualizationType"
        [myBetsListContext]="myBetsListContext()"
        [cashedOut]="cashedOut()" />
}

@if (isGridScoreboardEnabled()) {
    @if (event(); as value) {
        <ms-my-bets-scoreboard-wrapper [event]="value" />
    }
} @else if (isVisualizationTrackingEnabled()) {
    @if (event(); as value) {
        <ms-my-bets-condensed-scoreboard [event]="value" [bet]="bet()" [myBetsListContext]="myBetsListContext()" />
    }
} @else {
    <ng-content select="[default]" />
}
